import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Button, Col, Row,Container} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {DatePicker} from "../form/fields/DatePicker";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class ElectionFormData {
    @observable election_type_id = '';
    @observable name = '';
    @observable election_at = '';
    @observable is_active = true;
}

export class ElectionForm extends CrudForm {
    modelName = 'Election';

    renderFields() {
        return (
            <>

                <Field
                    label="Election Type"
                    name="election_type_id"
                    component={Select}
                    required={true}
                    loadOptions={api.electionType.getListAction}
                    store={this.formStore}
                />

                <Field
                    label="Election Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Election Date"
                    name="election_at"
                    component={DatePicker}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />

            </>
        );
    }
}

export class ElectionFilterForm {
    @observable election_type_id = '';
    @observable election_category_id = '';
}

export class ElectionList extends CrudList {
    modelName = 'Election';

    colums() {
        return [
            {
                name: "name",
                label: "Name",
				sort: true,
            },
            {
                name: "election_type.name",
                label: "Type",
				
            },
            {
                name: "structure",
                label: "Structure",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            <Button color="structure" onClick={() => this.goToElectionPollingUnits(item.id)}><span className="icon-structure"/></Button>
                        </>
                    );
                },
            },
            {
                name: "positions",
                label: "Positions",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            <Button color="positions" onClick={() => this.goToElectionPositions(item.id)}><span className="icon-candidates"/></Button>
                        </>
                    );
                },
            },
        ];
    }

    idColumn() {
        return '';
    }

    goToElectionPollingUnits(electionId: any) {
        window.location.href = '/elections/' + electionId + '/polling-units';
    }

    goToElectionPositions(electionId: any) {
        window.location.href = '/elections/' + electionId + '/positions';
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        name="election_type_id"
                        placeholder="Select Election Type"
                        component={Select}
                        required={true}
                        loadOptions={api.electionType.getListAction}
                        store={this.filterFormStore}
                        onChange={() => {
                            this.filterFormStore.setValue('election_id', null);
                        }}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class ElectionPage extends CrudPage {
    modelName = 'Election';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPage.tsx